import { OverlaySpinner } from '@ankr.com/ui';
import { Route } from 'react-router';
import loadable from '@loadable/component';

import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

const ROOT = '/dev/';

export const devRouteConfig = createRouteConfig(
  {
    dev: {
      path: ROOT,
      generatePath: () => ROOT,
    },
  },
  ROOT,
);

const DevPage = loadable(
  () => import('./screens/DevPage').then(m => m.DevPage),
  { fallback: <OverlaySpinner /> },
);

export function getDevRoutes(): JSX.Element {
  return <Route path={devRouteConfig.dev.path} element={<DevPage />} />;
}
